import React, { useState } from 'react';

import '../css/formForm.css'


const FormInput = (props) => {
    const [focused, setFocused] = useState(false);

    const handleFocus = (e) => {
        setFocused(true);
    }


    return ( 
        <div className="formInput">
            <label className='text_nofont'>{props.label} *</label>
            <input type={props.type} 
                placeholder={props.placeholder} 
                required={props.required} 
                pattern={props.pattern}
                onChange={e=>props.setValue(e.target.value)}
                onBlur={handleFocus}
                focused={focused.toString()}
            />
            <span className='text_nofont'>{props.span}</span>
        </div>
     );
};

export default FormInput;